import { Result, Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import TextContent from 'resources/Text-content.json';

const ErrorMsg = () => {
    
    const navigate = useNavigate();

    return (
        <Card>
            <Result
                status="error"
                title="Invalid Configuration"
                subTitle="Please check and modify the configuration file before resubmitting."
                extra={<Button type="primary" onClick={()=> navigate('/home')}>{TextContent?.reload}</Button>}
            />
        </Card>
    )
}

export default ErrorMsg;